var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormPage',{attrs:{"collectionName":_vm.collectionName,"tabs":_vm.tabs,"prevalidate":_vm.prevalidate,"id":_vm.$route.params.id,"showDeleteButton":true}})}
var staticRenderFns = []

export { render, staticRenderFns }